import { useQuery } from '@tanstack/react-query';

import { fetchTagById } from '../services/api/tags';

export const useTag = (tagId: string) => {
  return useQuery({
    queryKey: ['tag', tagId],
    queryFn: () => fetchTagById(tagId),
    enabled: Boolean(tagId),
  });
};
